import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="/icons/logo.jpeg" className="App-logo" alt="logo" />
        <p>
          Satyasaadhak - truth seeker...
        </p>
        <p>I think..that's what I do</p>
      </header>
    </div>
  );
}

export default App;
